<template>
    <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script>
    import {computed, onMounted} from '@vue/composition-api';
    import {DateTime} from "luxon";
    import XLSX from 'xlsx';
    import eConfig from "../../evention-config.js"

    export default {
        name: 'EventReportEvoucherGuest',
        setup(props, {root}) {
            const {Event, EvoucherGuest} = root.$FeathersVuex.api;

            const isTemplate = computed(() => root.$route.params.isTemplate);
            const eventId = computed(() => root.$route.params.eventId);
            const dbColMapping = eConfig.evoucher.dbColMapping;
            
            const exportEvoucher = async () => {
                const event = await Event.get(eventId.value);
                const {data: eventEvoucherArr} = await EvoucherGuest.find({
                    query: {
                        eventId: eventId.value,
                    },
                });
                
                const titleCols = Object.values(dbColMapping);
                
                let excelData = [];
                if (!isTemplate.value) {
                    for (let eventEvoucher of eventEvoucherArr) {
                        let evoucherRow = [];
                        for (let titleCol of titleCols) {
                            evoucherRow.push(eventEvoucher[titleCol] || '');
                        }
                        excelData.push(evoucherRow);
                    }
                }
                
                excelData.unshift([...Object.keys(dbColMapping)]);
                const ws = XLSX.utils.aoa_to_sheet(excelData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, event.name);
                XLSX.writeFile(wb, 'evoucher_'+eventId.value+'_'+DateTime.local().toFormat('yyyyMMdd_HHmmss')+'.xlsx');
                
                root.$router.go(-1);
            }
            
            onMounted(() => {
                exportEvoucher();
            });

            return {
            }
        },
    }
</script>
